import "./ladzo.less";
import ls from "local-storage";

//import * as fce from "./global/fce";

import * as bublina from "./incl/darek-bublina";

//--povoli konzoli
if (process.env.NODE_ENV == "development") {
  Lc.zobraz({ version: "2.0.1", appName: "5M" });
}

//--ulozeni kvuli testovani
let urlP = new URL(window.location.href);

if (urlP.searchParams.get("testDarku") == "true") {
  ls.set("testDarku", true);
} else if (urlP.searchParams.get("testDarku") == "false") {
  ls.remove("testDarku");
}

if (window.location.pathname == "/objednavka/krok-1/") {
  $('#order-billing-methods >.radio-wrapper[data-id="billing-92"]').each(
    function() {
      var $d = $(this);
      var inp = $d.find(">input.billingId-92");

      if (inp.length && inp.attr("id") == "inst-PAYMENT_CARD") {
        inp.attr("id", "inst-PAYMENT_CARD1");
        inp.next("label").attr("for", "inst-PAYMENT_CARD1");

        $d.find(".payment-info >b").html("EDENRED (Ticket Restaurant Card)");
        $d.find("label .payment-logo").html(
          '<img src="https://cdn.myshoptet.com/usr/www.hammernutrition.cz/user/system/edenredlogosmall.jpg" alt="EDENRED (Ticket Restaurant Card)">'
        );
      } else {
        $d.hide();
      }
    }
  );
}

let zobrazBubinu = false;
if ($(".cart-count").length || $("body").hasClass("in-kosik")) {
  zobrazBubinu = true;
}
Lc.log("zobrazBubinu");
Lc.log(zobrazBubinu);

if (zobrazBubinu) {
  bublina.zobraz();

  document.addEventListener("ShoptetCartUpdated", function() {
    //console.log("updatet");

    bublina.zobraz();
  });
}
